let viewPatientPersistence = Promise.resolve();
let viewPatientPersistenceVersion = 0;

export const getViewPatientPersistenceVersion = () =>
  viewPatientPersistenceVersion;

export const serializeViewPatientPersistence = (
  operation,
  isCurrent = () => true
) => {
  const current = viewPatientPersistence
    .catch((error) => {
      console.warn("viewPatientPersistenceQueue.js previous operation failed, continuing queue", error);
    })
    .then(async () => {
      if (!isCurrent()) return { outcome: "ignored" };
      const result = await operation();
      viewPatientPersistenceVersion += 1;
      return result;
    });
  viewPatientPersistence = current.catch((error) => {
    console.warn("viewPatientPersistenceQueue.js operation failed", error);
  });
  return current;
};

export default serializeViewPatientPersistence;
